import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

const hoverStyle = css`
    &:hover {
        border-color: ${colorsPalettes.carbon[300]};
    }
`;

const chipBase = css<{ $isClickable?: boolean; $isActive?: boolean }>`
    display: flex;
    align-items: center;
    width: fit-content;

    border-radius: 19px;
    border: 1px solid ${({ $isActive }) => ($isActive ? colorsPalettes.blue[400] : colorsPalettes.carbon[100])};
    cursor: ${({ $isClickable }) => ($isClickable ? "pointer" : "unset")};
    box-sizing: border-box;

    ${({ $isClickable, $isActive }) => ($isClickable && !$isActive ? hoverStyle : null)}
`;

export const StyledLeadScoreChip = styled(Text)<{ $isClickable?: boolean; $isActive?: boolean }>`
    ${chipBase}

    gap: 6px;
    padding: 4px 8px;
`;

export const StyledLeadScoreCountBadge = styled.button<{ $isClickable?: boolean; $isActive?: boolean }>`
    ${chipBase}
    ${setFontVariant("sectionTitle", colorsPalettes.carbon[400])}

    padding: 3px 8px;

    justify-content: center;
    background-color: transparent;
`;

export const StyledBarContainer = styled(Flex)`
    align-items: flex-end;
    gap: 2px;
    width: 19px;
    height: 14px;
`;

export const StyledBarItem = styled.div<{ height: number; color: string }>`
    width: 5px;
    height: ${(props) => props.height}px;
    background-color: ${(props) => props.color};
    border-radius: 1px 1px 0 0;
`;
